import { Form } from 'factorial-form'

class CompanySettingsVersionForm extends Form {
  constructor(values: Record<string, number | string | null | undefined>) {
    super(values, {
      id: 'string',
      company_id: 'string',
      effective_on: 'date',
      overnight_shifts_calculation_method: 'string',
    })
  }

  parsedData = () => {
    const formData = this.data()

    return {
      ...formData,
      effective_on: formData.effective_on,
    }
  }
}

export default CompanySettingsVersionForm
